import requireAll from '../requireAll';

import './_module';
import './other';
import './main';

requireAll(require.context('./auth', true, /(?!\.spec)(\S{5}|^\S{1,4})(\.js$|\.ts$)/));
requireAll(require.context('./config', true, /(?!\.spec)(\S{5}|^\S{1,4})(\.js$|\.ts$)/));
requireAll(require.context('./error-pages', true, /(?!\.spec)(\S{5}|^\S{1,4})(\.js$|\.ts$)/));
requireAll(require.context('./errors', true, /(?!\.spec)(\S{5}|^\S{1,4})(\.js$|\.ts$)/));
